import { ComponentProps } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';

import { spacing, Text, EmptyConnectionsImage } from '@pletly/ui';

export const EmptyConnections = ({ children, style, titleCategory = 'h6' }: Props) => {
	const { t } = useTranslation();

	return (
		<View style={[styles.root, style]}>
			<EmptyConnectionsImage />
			<Text category={titleCategory} style={styles.text} align="center">
				{t('connections.oops-look-like-you-dont-have-any-connections')}
			</Text>
			{children}
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		alignItems: 'center',
		paddingTop: spacing(3),
	},
	text: {
		marginVertical: spacing(2),
	},
});

type Props = Pick<ViewProps, 'style' | 'children'> & {
	titleCategory?: ComponentProps<typeof Text>['category'];
};
